import { Injectable } from '@angular/core';
import { LSRUIJson } from '../class/lsruiJson';
import { Device } from '../class/device';
import { Member } from '../class/member';
import { ActiveInfo } from '../class/activeInfo';
import { PanelistService } from './panelist.service';
import { environment } from 'src/environments/environment';
import { DeviceIdRequest } from '../interface/device-id-request';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  panelistJSON: LSRUIJson;
  activeInfo: ActiveInfo;
  newDeviceId = 0;

  private dataComputers: Device[];
  private dataSmartphones: Device[];
  private dataTablets: Device[];
  private dataRespondent: Member;
  private dataMembers: Member[];
  private _hhOptout = false;
  loaded = false;
  interviewer = false;

  constructor(
    private panelistService: PanelistService,
    private sharedService: SharedService
  ) { }
  checkInitialised(): boolean {
    if (
      this.dataComputers != null ||
      this.dataSmartphones != null ||
      this.dataTablets != null ||
      this.dataRespondent != null ||
      this.dataMembers != null
    ) {
      return true;
    }

    return false;
  }
  getComputer(index: number): Device {
    if (this.dataComputers != null) {
      if (index < this.dataComputers.length) {
        return this.dataComputers[index];
      }
    }
    return null;
  }
  getTablet(index: number): Device {
    if (this.dataTablets != null) {
      if (index < this.dataTablets.length) {
        return this.dataTablets[index];
      }
    }
    return null;
  }
  getSmartphone(index: number): Device {
    if (this.dataSmartphones != null) {
      if (index < this.dataSmartphones.length) {
        return this.dataSmartphones[index];
      }
    }
    return null;
  }
  getComputerIndex(id: number): number {
    let returnIndex = -1;
    if (this.dataComputers != null) {
      this.dataComputers.forEach((el, index) => {
        if (el.device_id === id) {
          returnIndex = index;
        }
      });
    }
    return returnIndex;
  }
  getTabletIndex(id: number): number {
    let returnIndex = -1;
    if (this.dataTablets != null) {
      this.dataTablets.forEach((el, index) => {
        if (el.device_id === id) {
          returnIndex = index;
        }
      });
    }
    return returnIndex;
  }
  getSmartphoneIndex(id: number): number {
    let returnIndex = -1;
    if (this.dataSmartphones != null) {
      this.dataSmartphones.forEach((el, index) => {
        if (el.device_id === id) {
          returnIndex = index;
        }
      });
    }
    return returnIndex;
  }
  getMember(index: number): Member {
    if (this.dataMembers != null) {
      if (index < this.dataMembers.length) {
        return this.dataMembers[index];
      }
    }
    return null;
  }

  getMembers(): Member[] {
    return this.dataMembers;
  }
  getRespondent(): Member {
    if (this.dataRespondent != null) {
      return this.dataRespondent;
    }
    return null;
  }
  getMemberIndex(id: number): number {
    let returnIndex = -1;
    if (this.dataMembers != null) {
      this.dataMembers.forEach((el, index) => {
        if (el.sdp_member_id === id) {
          returnIndex = index;
        }
      });
    }
    return returnIndex;
  }

  setComputer(index: number, device: Device) {
    if (this.dataComputers != null) {
      if (index < this.dataComputers.length) {
        this.dataComputers[index] = device;
        this.saveDevices();
      }
    }
    // console.log('something went wrong in saving computer');
  }
  setTablet(index: number, device: Device) {
    if (this.dataTablets != null) {
      if (index < this.dataTablets.length) {
        this.dataTablets[index] = device;
        this.saveDevices();
      }
    }
    // console.log('something went wrong in saving computer');
  }

  setSmartphone(index: number, device: Device) {
    if (this.dataSmartphones != null) {
      if (index < this.dataSmartphones.length) {
        this.dataSmartphones[index] = device;
        this.saveDevices();
      }
    }
    // console.log('something went wrong in saving computer');
  }

  setMembers(index: number, member: Member) {
    if (this.dataMembers.length > 0) {
      if (index < this.dataMembers.length) {
        member.member_type = 'Member';
        member.member_id = index + 2;
        this.dataMembers[index] = member;
        this.saveMember();
      }
    } else if (index === 0) {
      member.member_type = 'Member';
      this.dataMembers[index] = member;
      this.saveMember();
    }

    // console.log('something went wrong in saving computer');
  }

  setMemberCount(val: number) {
    if (!(this.dataMembers.length === val)) {
      if (this.dataMembers.length > val) {
        for (let j = this.dataMembers.length; j > val; j--) {
          this.dataMembers.pop();
        }
      } else if (this.dataMembers.length < val) {
        for (let j = this.dataMembers.length; j < val; j++) {
          const member = new Member();
          member.member_type = 'Member';
          member.participation.panel_optout = 'N';
          member.member_id = j + 2;
          this.dataMembers.push(member);
        }
      }
      this.saveMember();
    }
  }

  async setCoumputerCount(val: number) {
    if (!(this.dataComputers.length === val)) {
      if (this.dataComputers.length > val) {
        for (let j = this.dataComputers.length; j > val; j--) {
          this.dataComputers.pop();
        }
        this.saveDevices();
      } else if (this.dataComputers.length < val) {
        for (let j = this.dataComputers.length; j < val; j++) {
          const device = this.addDevice('Computer', j);
          await this.generateDeviceID();
          device.device_id = this.newDeviceId;
          device.sdp_device_id = device.device_id;
          device.device_number = this.getNextDeviceNum();
          this.dataComputers.push(device);
          this.saveDevices();
        }
      }
    }
  }
  async setTabletCount(val: number) {
    if (!(this.dataTablets.length === val)) {
      if (this.dataTablets.length > val) {
        for (let j = this.dataTablets.length; j > val; j--) {
          this.dataTablets.pop();
        }
        this.saveDevices();
      } else if (this.dataTablets.length < val) {
        for (let j = this.dataTablets.length; j < val; j++) {
          const device = this.addDevice('Tablet', j);
          await this.generateDeviceID();
          device.device_id = this.newDeviceId;
          device.sdp_device_id = device.device_id;
          device.device_number = this.getNextDeviceNum();
          this.dataTablets.push(device);
          this.saveDevices();
        }
      }
    }
  }
  async setSmartphoneCount(val: number) {
    if (!(this.dataSmartphones.length === val)) {
      if (this.dataSmartphones.length > val) {
        for (let j = this.dataSmartphones.length; j > val; j--) {
          this.dataSmartphones.pop();
        }
        this.saveDevices();
      } else if (this.dataSmartphones.length < val) {
        for (let j = this.dataSmartphones.length; j < val; j++) {
          const device = this.addDevice('Smartphone', j);
          await this.generateDeviceID();
          device.device_id = this.newDeviceId;
          device.sdp_device_id = device.device_id;
          device.device_number = this.getNextDeviceNum();
          this.dataSmartphones.push(device);
          this.saveDevices();
        }
      }
    }
  }
  getNextDeviceNum(): number {
    return this.panelistJSON.device.length === 0 ? 1 : Math.max.apply(Math, this.panelistJSON.device.map(el => el.device_number != null ? el.device_number : 0)) + 1;
  }

  addDevice(type: string, id: number): Device {
    const device = new Device();
    device.type = type;

    device.status = {
      add_date: 'null',
      remove_date: 'null',
      optout_flag: 'N'
    };
    return device;
  }

  setRespondent(member: Member) {
    if (!this.dataRespondent) {
      member.member_type = 'Respondent';
      member.member_id = 1;
      this.dataRespondent = member;
      this.saveMember();
    }
    // console.log('something went wrong in saving computer');
  }

  private saveDevices() {
    // console.log(this.panelistJSON);
    this.panelistJSON.device = [];
    this.panelistJSON.device = this.panelistJSON.device.concat(
      this.dataComputers
    );
    this.panelistJSON.device = this.panelistJSON.device.concat(
      this.dataTablets
    );
    this.panelistJSON.device = this.panelistJSON.device.concat(
      this.dataSmartphones
    );
    // console.log(this.panelistJSON);
  }
  private saveMember() {
    // console.log(this.panelistJSON);
    this.panelistJSON.member = [];
    this.panelistJSON.member = this.panelistJSON.member.concat(
      this.dataRespondent
    );
    this.panelistJSON.member = this.panelistJSON.member.concat(
      this.dataMembers
    );

    // console.log(this.panelistJSON);
  }
  generateDevices() {
    this.dataComputers = this.panelistJSON.device
      .filter(el => el.type === 'Computer')
      .sort((a, b) => (a.device_id > b.device_id ? 1 : -1))
      .sort((a, b) => (a.device_number > b.device_number ? 1 : -1));
    this.dataTablets = this.panelistJSON.device
      .filter(el => el.type === 'Tablet')
      .sort((a, b) => (a.device_id > b.device_id ? 1 : -1))
      .sort((a, b) => (a.device_number > b.device_number ? 1 : -1));
    this.dataSmartphones = this.panelistJSON.device
      .filter(el => el.type === 'Smartphone')
      .sort((a, b) => (a.device_id > b.device_id ? 1 : -1))
      .sort((a, b) => (a.device_number > b.device_number ? 1 : -1));
  }

  generateMembers() {
    this.dataRespondent = this.panelistJSON.member.find(
      el => el.member_type === 'Respondent'
    );

    this.dataMembers =
      this.panelistJSON.member.find(el => el.member_type !== 'Respondent') !=
        null
        ? this.panelistJSON.member
          .filter(el => el.member_type !== 'Respondent')
          .sort((a, b) => (a.member_id > b.member_id ? 1 : -1))
        : [];
  }

  async generateDeviceID() {
    const req: DeviceIdRequest = {
      countryId: environment.country === 'IT' ? 39 : 0,
      sdpHouseholdId: this.sharedService.sdpHouseholdId
    };

    await this.panelistService
      .getDeviceId(req)
      .toPromise()
      .then(res => {
        this.newDeviceId = res.deviceId;
      })
      .catch(err => console.log(err));

    // .subscribe(
    //   res => {
    //     deviceId = res.device_id;
    //   },
    //   err => {
    //     console.log(err);
    //   }
    // );
    // return deviceId;
    // const startOfTime = 974844 * 1000000; // 974844458581;
    // const currentTime = new Date().getTime() - startOfTime;
    // return Math.abs(
    //   Math.round(Math.random() * 1000000) +
    //     Math.floor((currentTime - startOfTime) / 1000)
    // );
  }

  set hhOptout(val: boolean) {
    this._hhOptout = val;
  }

  get ishhOptout(): boolean {
    return this._hhOptout;
  }

  reset() {
    this.panelistJSON = null;
    this.dataComputers = null;
    this.dataSmartphones = null;
    this.dataTablets = null;
    this.dataRespondent = null;
    this.dataMembers = null;
    this.hhOptout = false;
  }
  
  /**
   * Method to remove any newly added devices from the application state/memory.
   */
  removeAllNewDevices() {
    // All the newly added devices will have their device_id as 0.
    // So we can remove them by filtering only the non-zero device_id's.
    let conditionToRemoveDevice = device => device.device_id != 0;

    this.dataComputers = this.dataComputers.filter(conditionToRemoveDevice);
    this.dataTablets = this.dataTablets.filter(conditionToRemoveDevice);
    this.dataSmartphones = this.dataSmartphones.filter(conditionToRemoveDevice);

    this.saveDevices();
  }

  /**
   * Method to remove any newly added members from the application state/memory.
   */
   removeAllNewMembers() {
    // All the newly added members will have their sdp_member_id as 0.
    // So we can remove them by filtering only the non-zero sdp_member_id's.
    this.dataMembers = this.dataMembers.filter(member => member.sdp_member_id != 0);

    this.saveMember();
  }

  /**
   * Method to remove any newly added devices and members from the application state/memory.
   */
  removeAllNewDevicesAndMembers() {
    this.removeAllNewDevices()
    this.removeAllNewMembers()
  }

  /**
   * Method to check if any new device is present in the application memory
   * @returns {boolean}
   */
  hasNewDevice() {
    if (this.panelistJSON.device.filter(device => device.device_id === 0).length) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Method to check if any new device is present in the application memory
   * @returns {boolean}
   */
  hasNewMember() {
    if (this.panelistJSON.member.filter(member => member.sdp_member_id === 0).length) {
      return true;
    } else {
      return false;
    }
  }
}
